import React, { useCallback, useContext, useRef, useState } from 'react'
import { Col, Row, Card, Form, InputGroup, Container, Button, Collapse } from '@themesberg/react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendarAlt, faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons'
import Datetime from "react-datetime";
import moment from "moment-timezone";
import { Context } from '../CartGroup'

const _FilterForm = () => {

  const { state, dispatch } = useContext(Context);
  const [showAdvanced, setShowAdvanced] = useState(false);

  const _phone = useRef(state.phone);
  const _cartGroupId = useRef(state.cartGroupId);
  const _gameId = useRef(state.gameId);
  const _status = useRef(state.status);

  // Date refs for each filter type
  const _createdFrom = useRef(state.createdFrom);
  const _createdTo = useRef(state.createdTo);
  const _activatedFrom = useRef(state.activatedFrom);
  const _activatedTo = useRef(state.activatedTo);
  const _completedFrom = useRef(state.completedFrom);
  const _completedTo = useRef(state.completedTo);
  const _canceledFrom = useRef(state.canceledFrom);
  const _canceledTo = useRef(state.canceledTo);
  const _rewardedFrom = useRef(state.rewardedFrom);
  const _rewardedTo = useRef(state.rewardedTo);

  // Check if this is the search page (no fixed status)
  const isSearchPage = state.status === '' || state.status === undefined;

  const pageTitleByStatus = {
    0: 'Chờ kích hoạt',
    1: 'Đang góp',
    2: 'Đã hoàn thành',
    3: 'Đã hủy',
    4: 'Trúng thưởng',
    5: 'Không trúng thưởng',
    6: 'Đã bị xóa',
    'completed': 'Đã hoàn thành',
  };
  const pageTitle = state.status !== undefined && state.status !== '' && pageTitleByStatus[state.status] != null
    ? pageTitleByStatus[state.status]
    : 'Danh sách nhóm mua chung';

  // Determine which date field to show based on status
  const getDateConfig = () => {
    const currentStatus = isSearchPage ? _status.current : state.status;
    switch (currentStatus) {
      case 0: return { label: 'Ngày tạo', fromRef: _createdFrom, toRef: _createdTo, fromKey: 'createdFrom', toKey: 'createdTo' };
      case 1: return { label: 'Ngày kích hoạt', fromRef: _activatedFrom, toRef: _activatedTo, fromKey: 'activatedFrom', toKey: 'activatedTo' };
      case 2:
      case 'completed': return { label: 'Ngày hoàn thành', fromRef: _completedFrom, toRef: _completedTo, fromKey: 'completedFrom', toKey: 'completedTo' };
      case 3: return { label: 'Ngày hủy', fromRef: _canceledFrom, toRef: _canceledTo, fromKey: 'canceledFrom', toKey: 'canceledTo' };
      case 4: return { label: 'Ngày trúng thưởng', fromRef: _rewardedFrom, toRef: _rewardedTo, fromKey: 'rewardedFrom', toKey: 'rewardedTo' };
      case 5: return { label: 'Ngày hoàn thành', fromRef: _completedFrom, toRef: _completedTo, fromKey: 'completedFrom', toKey: 'completedTo' };
      default: return { label: 'Ngày tạo', fromRef: _createdFrom, toRef: _createdTo, fromKey: 'createdFrom', toKey: 'createdTo' };
    }
  };

  const dateConfig = getDateConfig();

  const _handleChangePhone = useCallback((payload) => {
    _phone.current = payload.target.value
  }, [])

  const _handleChangeCartGroupId = useCallback((payload) => {
    _cartGroupId.current = payload.target.value
  }, [])

  const _handleChangeGame = useCallback((payload) => {
    _gameId.current = payload.target.value
  }, [])

  const _handleChangeStatus = useCallback((payload) => {
    _status.current = payload.target.value !== '' ? Number(payload.target.value) : ''
  }, [])

  const _submitForm = useCallback(() => {
    const currentStatus = isSearchPage ? _status.current : state.status;

    // Only send the date filter relevant to the current status
    const datePayload = {};
    switch (currentStatus) {
      case 0:
        datePayload.createdFrom = _createdFrom.current;
        datePayload.createdTo = _createdTo.current;
        break;
      case 1:
        datePayload.activatedFrom = _activatedFrom.current;
        datePayload.activatedTo = _activatedTo.current;
        break;
      case 2:
      case 'completed':
        datePayload.completedFrom = _completedFrom.current;
        datePayload.completedTo = _completedTo.current;
        break;
      case 3:
        datePayload.canceledFrom = _canceledFrom.current;
        datePayload.canceledTo = _canceledTo.current;
        break;
      case 4:
      case 5:
        datePayload.rewardedFrom = _rewardedFrom.current;
        datePayload.rewardedTo = _rewardedTo.current;
        break;
      default:
        // Search page with no specific status: use createdFrom/createdTo
        datePayload.createdFrom = _createdFrom.current;
        datePayload.createdTo = _createdTo.current;
        break;
    }

    dispatch({
      type: 'SUBMIT_FILTER',
      payload: {
        ...datePayload,
        phone: _phone.current,
        cartGroupId: _cartGroupId.current,
        gameId: _gameId.current,
        status: currentStatus
      }
    })
  }, [dispatch, state.status, isSearchPage])

  return (
    <>
      <Card border="light" className="shadow-sm">
        <Card.Header>
          <Row className="align-items-center">
            <Col className='align-self-center'>
              <h5>{pageTitle}</h5>
            </Col>
            <Col className='text-right'>
              <Button variant="info" type="submit" onClick={_submitForm}>Tìm kiếm</Button>
            </Col>
          </Row>
        </Card.Header>
        <Card.Body>
          <Container>
            <Row className='p-1'>
              {/* Search by ID - only show when advanced is hidden */}
              {!showAdvanced && (
              <Col md={6}>
                <Form.Control
                  type="text"
                  placeholder="Nhập mã nhóm (ID) để tìm trực tiếp"
                  defaultValue={state.cartGroupId ?? ''}
                  onChange={_handleChangeCartGroupId}
                />
              </Col>
              )}
              <Col md={showAdvanced ? 12 : 6} className="d-flex align-items-center">
                <Button 
                  variant="link" 
                  onClick={() => setShowAdvanced(!showAdvanced)}
                  className="text-decoration-none p-0"
                >
                  <FontAwesomeIcon icon={showAdvanced ? faChevronUp : faChevronDown} className="me-2" />
                  {showAdvanced ? 'Tìm theo mã nhóm' : 'Bộ lọc nâng cao'}
                </Button>
              </Col>
            </Row>

            {/* Advanced filters - Collapsible */}
            <Collapse in={showAdvanced}>
              <div>
                <hr className="my-3" />

                <Row className='p-1'>
                  <Col md={6}>
                    <Row>
                      <Col md={3} className='text-right align-self-center'>
                        <Form.Label>{dateConfig.label} từ</Form.Label>
                      </Col>
                      <Col md={9}>
                        <Datetime
                          timeFormat={false}
                          onChange={(val) => { dateConfig.fromRef.current = val }}
                          renderInput={(props, openCalendar) => (
                            <InputGroup>
                              <InputGroup.Text><FontAwesomeIcon icon={faCalendarAlt} /></InputGroup.Text>
                              <Form.Control
                                required
                                type="text"
                                value={dateConfig.fromRef.current ? moment(dateConfig.fromRef.current).format("DD/MM/YYYY") : ""}
                                placeholder="dd/mm/yyyy"
                                onFocus={openCalendar}
                                onChange={() => { }} />
                            </InputGroup>
                          )}
                        />
                      </Col>
                    </Row>
                  </Col>
                  <Col md={6}>
                    <Row>
                      <Col md={3} className='text-right align-self-center'>
                        <Form.Label>{dateConfig.label} đến</Form.Label>
                      </Col>
                      <Col md={9}>
                        <Datetime
                          timeFormat={false}
                          onChange={(val) => { dateConfig.toRef.current = val }}
                          renderInput={(props, openCalendar) => (
                            <InputGroup>
                              <InputGroup.Text><FontAwesomeIcon icon={faCalendarAlt} /></InputGroup.Text>
                              <Form.Control
                                required
                                type="text"
                                value={dateConfig.toRef.current ? moment(dateConfig.toRef.current).format("DD/MM/YYYY") : ""}
                                placeholder="dd/mm/yyyy"
                                onFocus={openCalendar}
                                onChange={() => { }} />
                            </InputGroup>
                          )}
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>

                <Row className='p-1'>
                  <Col md={6}>
                    <Row>
                      <Col md={3} className='text-right align-self-center'>
                        <Form.Label>Trò chơi</Form.Label>
                      </Col>
                      <Col md={9}>
                        <Form.Select onChange={_handleChangeGame}>
                          <option defaultValue value={''}>Tất cả</option>
                          <option value={'lotto535'}>LOTO 5/35</option>
                          <option value={'mega'}>Mega 6/45</option>
                          <option value={'power'}>Power 6/55</option>
                        </Form.Select>
                      </Col>
                    </Row>
                  </Col>
                  {state.status !== 0 && (
                  <Col md={6}>
                    <Row>
                      <Col md={3} className='text-right align-self-center'>
                        <Form.Label>SĐT thành viên</Form.Label>
                      </Col>
                      <Col md={9}>
                        <Form.Control
                          type="text"
                          placeholder="Nhập số điện thoại"
                          defaultValue={state.phone ?? ''}
                          onChange={_handleChangePhone}
                        />
                      </Col>
                    </Row>
                  </Col>
                  )}
                </Row>

                {isSearchPage && (
                <Row className='p-1'>
                  <Col md={6}>
                    <Row>
                      <Col md={3} className='text-right align-self-center'>
                        <Form.Label>Trạng thái</Form.Label>
                      </Col>
                      <Col md={9}>
                        <Form.Select onChange={_handleChangeStatus} defaultValue={''}>
                          <option value={''}>Tất cả</option>
                          <option value={0}>Không hoạt động</option>
                          <option value={1}>Đang góp</option>
                          <option value={2}>Đã hoàn thành</option>
                          <option value={3}>Đã hủy</option>
                          <option value={4}>Trúng thưởng</option>
                          <option value={5}>Không trúng thưởng</option>
                          <option value={6}>Đã bị xóa</option>
                        </Form.Select>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                )}
              </div>
            </Collapse>
          </Container>
        </Card.Body>
      </Card>
    </>
  );
};

export default React.memo(_FilterForm)